import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

const STORAGE_KEY = "lrc-cookie-consent";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  const c = t.legal.cookie;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-x-0 bottom-0 z-[70] flex justify-center px-4 pb-4"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookie-banner"
        >
          <div className="flex w-full max-w-3xl flex-col gap-4 rounded-xl border border-gold/40 bg-navy/95 px-6 py-5 text-canvas shadow-[0_20px_60px_-20px_rgba(0,0,0,0.7)] backdrop-blur-md sm:flex-row sm:items-center">
            <p className="flex-1 text-sm leading-relaxed text-canvas/80">
              {c.text}{" "}
              <Link to="/privacy" className="text-goldsoft underline underline-offset-4 hover:text-gold" data-testid="cookie-more-link">
                {c.more}
              </Link>
            </p>
            <button
              type="button"
              onClick={accept}
              data-testid="cookie-accept-button"
              className="shrink-0 rounded-full border border-gold bg-gold px-7 py-3 text-sm font-medium uppercase tracking-[0.15em] text-navy transition-colors hover:bg-transparent hover:text-goldsoft"
            >
              {c.accept}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
